import api from '../../../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { IncentiveCampaignRankingType } from 'domains/loyalty.d';

export const getIncentiveCampaignRanking: QueryFunction<IncentiveCampaignRankingType> = async ({
  queryKey: [campaignId],
}) => await api.get(`/loyalty/incentive-campaign/${campaignId}/ranking`).then((resp) => resp.data);
